import { ArrowUturnLeftIcon, ArrowUturnRightIcon } from '@heroicons/react/24/solid'
import classNames from 'classnames'
import { MediaImage } from 'iconoir-react'
import { useImageCropContext } from './ImageCropProvider'

export const ZoomSlider = ({ className }) => {
  const { zoom, setZoom, handleZoomIn, handleZoomOut, max_zoom, min_zoom, zoom_step } = useImageCropContext()

  return (
    <div className={classNames(className, `flex items-center justify-center gap-2`)}>
      <button className="p-1" onClick={handleZoomOut}>
        <MediaImage className="w-6 text-default" />
      </button>
      <input
        type="range"
        name="volju"
        min={min_zoom}
        max={max_zoom}
        step={zoom_step}
        value={zoom}
        onChange={(e) => {
          setZoom(Number(e.target.value))
        }}
      />
      <button className="p-1" onClick={handleZoomIn}>
        <MediaImage className="w-4 text-default" />
      </button>
    </div>
  )
}

export const RotationSlider = ({ className }) => {
  const { rotation, setRotation, max_rotation, min_rotation, rotation_step, handleRotateAntiCw, handleRotateCw } =
    useImageCropContext()

  return (
    <div className={classNames(className, `flex items-center justify-center gap-2`)}>
      <button className="p-1" onClick={handleRotateAntiCw}>
        <ArrowUturnLeftIcon className="w-4 text-minimal" />
      </button>
      <input
        type="range"
        name="volju"
        min={min_rotation}
        max={max_rotation}
        step={rotation_step}
        value={rotation}
        onChange={(e) => {
          setRotation(Number(e.target.value))
        }}
      />
      <button className="p-1" onClick={handleRotateCw}>
        <ArrowUturnRightIcon className="w-4 text-minimal" />
      </button>
    </div>
  )
}
